import AppParameter from './AppParameter';

export default AppParameter;